import CheckCircle from "@mui/icons-material/CheckCircle";
import Autorenew from "@mui/icons-material/Autorenew";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { format, parseISO } from "date-fns";
import { useQuery } from "react-query";
import { Table } from "../../components/Table";
import { listEnrichment } from "../../services/enrichment";
import { useStyles } from "./styles";
import Visibility from "@mui/icons-material/Visibility";
import Paper from "@mui/material/Paper";
import { useCallback, useState } from "react";
import { queryClient } from "../../services/queryClient";
import { Enrichment as TypeEnrichment } from "../../types/enrichment";
import { NewEnrichment } from "./New";
import { DetailsEnrichment } from "./Details";
import { green } from "@mui/material/colors";

export function Enrichment() {
  const [enrichment, setEnrichment] = useState<TypeEnrichment | null>(null);
  const [dialogNewEnrichment, setDialogNewEnrichment] =
    useState<boolean>(false);
  const [dialogDetailsEnrichment, setDialogDetailsEnrichment] =
    useState<boolean>(false);
  const styles = useStyles();

  const enrichments = useQuery("enrichments", listEnrichment);

  const invalidateEnrichments = useCallback(() => {
    queryClient.invalidateQueries("enrichments");
  }, []);

  const handleDialogNewEnrichment = useCallback(() => {
    setDialogNewEnrichment((prev) => !prev);
  }, []);

  const handleDialogDetailsEnrichment = useCallback(
    (row: TypeEnrichment | null) => {
      setEnrichment(row);
      setDialogDetailsEnrichment((prev) => !prev);
    },
    []
  );

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Enriquecimento</Typography>
      </div>
      <div className={styles.rootActions}>
        <Button variant="contained" onClick={handleDialogNewEnrichment}>
          Enriquecer
        </Button>
        <Tooltip title="Atualizar lista" placement="top">
          <IconButton
            className={styles.btnPutList}
            onClick={invalidateEnrichments}
          >
            <Autorenew />
          </IconButton>
        </Tooltip>
      </div>

      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          toolbar={false}
          data={enrichments.data as []}
          isLoading={enrichments.isFetching}
          columns={[
            { title: "#", field: "id_base" },
            { title: "Audiência", field: "nome_prospeccao" },
            {
              title: "Data de enriquecimento",
              field: "data_insert",
              render: (row) =>
                format(
                  parseISO(row.data_insert?.replace("Z", "")),
                  "dd/MM/yyyy HH:mm"
                ),
            },
            {
              title: "Status do enriquecimento",
              align: "center",
              field: "processado",
              render: (row) =>
                Boolean(row.processado) ? (
                  <Tooltip title="Audiência enriquecida" placement="top">
                    <CheckCircle style={{ fontSize: 25, color: green[600] }} />
                  </Tooltip>
                ) : (
                  <Tooltip title="Enriquecimento em andamento" placement="top">
                    <CircularProgress size={22} thickness={4} />
                  </Tooltip>
                ),
            },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Tooltip title="Ver detalhes" placement="top">
                  <IconButton
                    onClick={() => handleDialogDetailsEnrichment(row)}
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
              ),
            },
          ]}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
        <NewEnrichment
          open={dialogNewEnrichment}
          onClose={handleDialogNewEnrichment}
        />
        <DetailsEnrichment
          data={enrichment}
          open={dialogDetailsEnrichment}
          onClose={() => handleDialogDetailsEnrichment(null)}
        />
      </Paper>
    </>
  );
}
